import { render } from "./NewspaperList.vue?vue&type=template&id=0ba749cf"
import script from "./NewspaperList.vue?vue&type=script&lang=js"
export * from "./NewspaperList.vue?vue&type=script&lang=js"

import "./NewspaperList.vue?vue&type=style&index=0&id=0ba749cf&lang=scss"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__